// Избор на начин на получаване на наема — НА НИВО ИМОТ.
// При SEPA наемодателят вижда прогнозата ВЕДНАГА, преди да потвърди.

import React, { useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { showError, showSuccess } from '../../toast';
import { api } from '../../api';
import { Button, Card, COLORS, Muted, Screen, Title } from '../../ui';
import { t } from '../../i18n';

// Функция, а не константа — етикетите се преизчисляват при смяна на езика
const METHODS = () => [
  {
    key: 'BANK_TRANSFER',
    label: t('По банка (IBAN)'),
    hint: t('Наемателят превежда сам с уникален код за основание. Нула такси.'),
    disabled: false,
  },
  {
    key: 'CASH',
    label: t('В брой'),
    hint: t('Двустранно потвърждение в приложението + автоматична бележка.'),
    disabled: false,
  },
  {
    // Авто-тегленето (SEPA) изисква реален платежен доставчик — още не е
    // пуснато. Показва се неактивно, за да се знае, че идва.
    key: 'SEPA_DEBIT',
    label: t('Автоматично теглене (SEPA)'),
    hint: t('Наемът се тегли сам всеки месец от сметката на наемателя.'),
    disabled: true,
  },
] as const;

export default function PaymentMethodScreen({ route, navigation }: any) {
  const { apartmentId, currentMethod, monthlyRentCents } = route.params;
  // SEPA не се предлага — имот, останал на него, пада на „По банка"
  const [method, setMethod] = useState<string>(currentMethod === 'SEPA_DEBIT' ? 'BANK_TRANSFER' : currentMethod);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api(`/apartments/${apartmentId}`, { method: 'PATCH', body: { rentCollectionMethod: method } });
      showSuccess(t('Начинът на получаване е обновен.'));
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Получаване на наема')}</Title>
      <Muted>{t('Изборът важи само за този имот — за друг имот може да е различен.')}</Muted>

      <Card style={{ marginTop: 12 }}>
        {METHODS().map((m) => (
          <Pressable
            key={m.key}
            disabled={m.disabled}
            onPress={() => setMethod(m.key)}
            style={{
              flexDirection: 'row',
              paddingVertical: 12,
              borderBottomWidth: 1,
              borderBottomColor: COLORS.border,
              opacity: m.disabled ? 0.45 : 1, // светло сиво, неизбираемо
            }}
          >
            <View
              style={{
                width: 20,
                height: 20,
                borderRadius: 10,
                borderWidth: 2,
                marginTop: 2,
                borderColor: !m.disabled && method === m.key ? COLORS.primary : COLORS.muted,
                backgroundColor: !m.disabled && method === m.key ? COLORS.primary : 'transparent',
                marginRight: 10,
              }}
            />
            <View style={{ flex: 1 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <Text style={{ fontSize: 16, color: m.disabled ? COLORS.muted : COLORS.text, fontWeight: !m.disabled && method === m.key ? '600' : '400' }}>
                  {m.label}
                </Text>
                {m.disabled && (
                  <View style={{ backgroundColor: COLORS.bg, borderWidth: 1, borderColor: COLORS.border, borderRadius: 999, paddingHorizontal: 8, paddingVertical: 2 }}>
                    <Text style={{ fontSize: 11, fontWeight: '700', color: COLORS.muted }}>{t('СКОРО')}</Text>
                  </View>
                )}
              </View>
              <Text style={{ fontSize: 12, color: COLORS.muted }}>{m.hint}</Text>
            </View>
          </Pressable>
        ))}
      </Card>

      <Button title={t('Потвърди избора')} onPress={save} loading={saving} />
    </Screen>
  );
}
